module.exports = __webpack_public_path__ + "img/photo-5.87b7a0d0.webp";